
// https://datatracker.ietf.org/doc/html/rfc5424

export type LogLevel =
 | typeof LogLevelEmergency
 | typeof LogLevelAlert
 | typeof LogLevelCritical
 | typeof LogLevelError 
 | typeof LogLevelWarning
 | typeof LogLevelNotice
 | typeof LogLevelInformational
 | typeof LogLevelDebug

export const LogLevelEmergency  = {
	code: 0,
	name: 'Emergency'
}

export const LogLevelAlert  = {
	code: 1,
	name: 'Alert'
}

export const LogLevelCritical = {
	code: 2,
	name: 'Critical'
}

export const LogLevelError = {
	code: 3,
	name: 'Error'
}

export const LogLevelWarning = {
	code: 4,
	name: 'Warning'
}

export const LogLevelNotice = {
	code: 5,
	name: 'Notice'
}

export const LogLevelInformational = {
	code: 6,
	name: 'Informational'
}

export const LogLevelDebug = {
	code: 7,
	name: 'Debug'
}
